import React, { useEffect, useState } from "react";

import { ExpandLess } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { primaryAccentColor } from "@/src/theme/helpers";

const SCROLL_Y_LIMIT = 240;

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(window.scrollY > SCROLL_Y_LIMIT);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > SCROLL_Y_LIMIT ? true : false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <IconButton
      sx={(muiTheme) => ({
        position: "fixed",
        display: isVisible ? "flex" : "none",
        right: "1rem",
        bottom: "1rem",
        border: "1px solid",
        borderColor: primaryAccentColor(muiTheme),
        backgroundColor: muiTheme.palette.background.paper,
        "&:hover": {
          backgroundColor: muiTheme.palette.action.hover
        },
        zIndex: 100
      })}
      onClick={() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }}
    >
      <ExpandLess
        sx={(muiTheme) => ({ color: primaryAccentColor(muiTheme) })}
      />
    </IconButton>
  );
};

export default ScrollToTop;
